import React from 'react';
import ChiSonoTemplate from '../../components/template-chi-sono';
import { getProp, getPropAsset, getPropRel } from '../utils';

const ChiSonoPreview = (props) => {
  const title = getProp(props, 'title');
  const profile = getPropAsset(props, 'profile');
  const paragraphs = getPropRel(props, 'paragraphs', 'text-row-2');

  return <ChiSonoTemplate data={{ title, profile, paragraphs }} />;
};

export default ChiSonoPreview;
